// API 기본 URL 설정 (상대 경로 사용)
const DEFAULT_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export const SPEED_BACKEND_BASE_URL =
  process.env.REACT_APP_SPEED_BACKEND_URL || process.env.REACT_APP_API_BASE_URL || '/api';

export const buildApiUrl = (path: string) => {
  const normalizedBase = SPEED_BACKEND_BASE_URL.replace(/\/$/, '');
  let normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // /api/api/ 중복 방지: path에 이미 /api가 포함되어 있으면 제거
  if (normalizedPath.startsWith('/api/')) {
    normalizedPath = normalizedPath.replace(/^\/api/, '');
  }
  
  const finalUrl = `${normalizedBase}${normalizedPath}`;
  
  // 최종 URL에서 /api/api/ 중복 제거 (안전장치)
  return finalUrl.replace(/\/api\/api\//g, '/api/');
};

